import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "cw-icon-holder"
}
const _hoisted_2 = { class: "cw-message-content" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 1,
  class: "cw-attachments"
}
const _hoisted_5 = {
  key: 2,
  class: "cw-reply-options"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TickAvatar = _resolveComponent("TickAvatar")!
  const _component_Attachment = _resolveComponent("Attachment")!
  const _component_BaseReplyOption = _resolveComponent("BaseReplyOption")!

  return (this.hasData)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["cw-message", { 'isMe': this.messageIsFromMe(this.message), 'showFullScreen': this.showFullScreen, 'show-avatar': this.showAvatar, 'same-sender': this.sameSenderAsBefore, 'positionAllMessagesLeft': this.positionAllMessagesLeft }])
      }, [
        (this.showAvatar)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (!this.sameSenderAsBefore)
                ? (_openBlock(), _createBlock(_component_TickAvatar, {
                    key: 0,
                    class: "icon",
                    sender: this.messageSenderInfo
                  }, null, 8, ["sender"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_2, [
          (this.messageHtml)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["cw-message-text", { 'use-custom-padding': this.useCustomPadding }]),
                innerHTML: this.messageHtml
              }, null, 10, _hoisted_3))
            : _createCommentVNode("", true),
          (this.hasAttachments)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.attachments, (attachment, index) => {
                  return (_openBlock(), _createBlock(_component_Attachment, {
                    attachmentLink: attachment,
                    key: index
                  }, null, 8, ["attachmentLink"]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (this.hasReplyOptions)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.replyOptions, (replyOption, index) => {
                  return (_openBlock(), _createBlock(_component_BaseReplyOption, {
                    data: replyOption,
                    index: index,
                    useCustomActionPadding: this.useCustomActionPadding,
                    key: index
                  }, null, 8, ["data", "index", "useCustomActionPadding"]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ], 2))
    : _createCommentVNode("", true)
}